var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{ref:"pageTabs",attrs:{"type":_vm.borderStyle ? 'border-card' : '',"value":_vm.defaultTabName},on:{"tab-click":_vm.toggleTab}},_vm._l((_vm.validTabs),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.label,"name":item.name}},[_vm._t(item.name)],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556cb9a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageTabs.vue
// module id = null
// module chunks = 